require('./bootstrap');

require('alpinejs');

window.tippy('[data-tippy-content]', {
    // duration: [300, 250],
    // animation: 'scale',
    // animation: 'shift-away',
    // animation: 'shift-toward',
});